// extracted by mini-css-extract-plugin
export default {"row":"card_row__AErPV","label":"card_label__l3XS9","value":"card_value__ahurz","symbol":"card_symbol__OFb9I"};